import React from 'react';

export default function EditSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.7193 8.52768L20.6232 6.34312L4.3605 23.1336L3.11839 28.8034L8.59787 27.5181L24.838 10.72L22.7193 8.52768Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M28.8813 2.20683C27.7112 0.99607 25.8141 0.99607 24.6439 2.20683L20.6243 6.33695L24.8169 10.7145L28.8813 6.59139C30.0514 5.38063 30.0514 3.41759 28.8813 2.20683Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
